var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCoupleNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 50,
  fill: "none",
  viewBox: "0 0 62 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 31.204c0 6.943 4.202 10.05 8.953 10.05 4.933 0 8.404-3.472 8.404-8.223 0-4.75-2.74-6.943-7.49-8.77-.914-.365-1.828-1.096-1.828-2.558 0-4.933 4.75-8.404 12.973-11.693L28.098 8C16.953 12.02 8 18.049 8 31.204m24.118 0c0 6.943 4.202 10.05 8.953 10.05 4.933 0 8.404-3.472 8.404-8.223 0-4.75-2.74-6.943-7.491-8.77-.913-.365-1.827-1.096-1.827-2.558 0-4.933 4.75-8.404 12.972-11.693L52.216 8C41.07 12.02 32.118 18.049 32.118 31.204"
})));
export { SvgCoupleNote as ReactComponent };